module.exports = __webpack_public_path__ + "static/media/Work-Sans-regular.374d1be1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Work-Sans-regular/Work-Sans-regular.ttf
// module id = 421
// module chunks = 0